// 费用明细
// 仓库明细

import { HttpGetWareList } from '@/service/costbilling';
import TableList from "@components/templates/tablelist";
import comExcel from '@components/templates/excelalert';
import { mapState, mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {

            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpGetWareList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/cost/billingCostOrderTransaction/export", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'post'
                        }
                    ).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList','getAdminTransferWarehouse', 'getWarehouseList', 'getCusproductList', 'getFirstLevelList', 'getSecondLevelList', 'getThirdLevelList', 'getBillcusWareList']),
        ...mapGetters('common', ['getBussinessTypeList','getBillingDetailStatus']),
        ToolsData() {
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "组织",
                    key: 'EQ_organizationId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "仓库",
                    key: 'EQ_orgWarehouseCode',
                    show: true,
                    tag: 'vSelect',
                    options:this.getAdminTransferWarehouse,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "账单",
                    key: 'EQ_billNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "业务类型",
                    key: 'EQ_businessType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getBussinessTypeList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "一级分类",
                    key: 'EQ_firstBillingCategoryId',
                    options: this.getFirstLevelList,
                    more: true,
                    tag: 'vSelect',
                    props: {

                    },
                },
                {
                    label: "二级分类",
                    key: 'EQ_secondBillingCategoryId',
                    options: this.getSecondLevelList,
                    more: true,
                    tag: 'vSelect',
                    props: {

                    },
                },
                {
                    label: "三级分类",
                    key: 'EQ_thirdBillingCategoryId',
                    options: this.getThirdLevelList,
                    more: true,
                    tag: 'vSelect',
                    props: {

                    },
                },

                {
                    label: "计费单号",
                    key: 'EQ_relOrderNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: "识别号",
                    key: 'EQ_sourceNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: "集装箱号",
                    key: 'EQ_containerNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: "SKU",
                    key: 'EQ_relSku',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: "项目",
                    key: 'EQ_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                },
                // {
                //     label: "状态",
                //     key: 'EQ_billId',
                //     more: true,
                //     tag: 'vSelect',
                //     options: this.getBillingDetailStatus,
                //     props: {
                //         filterable: true,
                //     },
                //     // on: {
                //     //     'on-change': function(value, label, attach = {}) {
                //     //         if(label=='已出账'){
                //     //             this.formData = {
                //     //                 ...this.formData,
                //     //                 'search[NE_billId]':0
                //     //             }
                //     //         }
                //     //     },
                //     // }
                //     // on: {
                //     //     'on-change': val => {
                //     //         console.log(val);
                //     //         if(val==1){
                //     //             this.key="NE_billId";
                //     //             this.val=0;
                //     //         }
                //     //     }
                //     // },
                //     // on: {
                //     //     'on-attach': (attach) => { this.formData.orgWarehouseCode = attach.code }
                //     // },
                //     // on: {
                //     //     'on-change': (val) => {
                //     //         // const data = this.productList.find(item => item.sku == val);
                //     //         this.boundFormData = { sku: val }
                //     //     }
                //     // },
                // },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },

            ]
        },
        columns() {
            return [{
                title: '组织/仓库',
                key: 'organizationName',
                render: (h, { row }) => {
                    return <div>
                        <div>{row.organizationName}</div>
                        <div>{row.orgWarehouseCode}</div>
                    </div>
                }
            },
            {
                title: '账单',
                key: 'billNo',
                width: 100,
                render: (h, { row }) => {
                    return <div>
                        账单 : {row.billNo}
                        <div>状态:{row.billId == 0 ? '未出账' : '已出账'}</div>
                    </div>
                }
            },
            {
                title: '业务类型/一级分类/二级分类/三级分类',
                width: 250,
                render: (h, { row }) => {
                    let businessType = row.businessType
                    const { label } = this.getBussinessTypeList.find(function (item) {
                        return item.value == businessType
                    }) || {};
                    return <div>
                        <div>{label || '--'}</div>
                        <div>{row.firstBillingCategoryName}</div>
                        <div>{row.secondBillingCategoryName}</div>
                        <div>{row.thirdBillingCategoryName}</div>
                    </div>
                }
            },
            {
                title: '项目/SKU',
                render: (h, { row }) => {
                    return <div>
                        <div>{row.lineName || '--'}</div>
                        <div>{row.relSku || '--'}</div>
                    </div>
                }
            },
            {
                title: '费率*数量',
                width: 90,
                sortable: true,
                render(h, { row }) {
                    return <div>{row.rate || '--'} * {row.count || '--'}</div>
                }

            },
            {
                title: '拣货难度系数',
                width: 100,
                sortable: true,
                render(h, { row }) {
                    return <div>{row.otherCoefficient || '--'}</div>
                }

            },
            {
                title: '总费用',
                sortable: true,
                render(h, { row }) {
                    return `${row.cost} ${row.currency || 'USD'}`
                }

            },
            {
                title: '计费单号/识别号/集装箱号',
                width: 170,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.relOrderNo || '--'}</div>
                        <div>{row.sourceNo || '--'}</div>
                        <div>{row.containerNo || '--'}</div>
                    </div>
                }
            },
            {
                title: '备注',
                key: 'remark',

            },
            {
                title: '创建时间',
                key: 'createdAt',
                width: 80,
            }];
        },
    },
};




